import CardDto from '../interfaces/CardDto'
import { formatDateToDDMMYYYY } from '../utils/utils'

const CardTwo: React.FC<{ cards: CardDto[] }> = ({ cards }) => {
  return (
    <div>
      <div className="grid grid-cols-9">
        <div>Cliente</div>
        <div>Vehículo</div>
        <div>Banco</div>
        <div>Patente</div>
        <div>Fecha Solicitud</div>
        <div>Monto</div>
      </div>
      {cards.map((card) => (
        <div key={card.id} className="grid grid-cols-9">
          <div>{card.vehicle?.year}</div>
          <div>{card.vehicle?.brand}</div>
          <div>{card.vehicle?.model}</div>
          <div>{card.vehicle?.plate}</div>
          <div>{card.client?.lastname}</div>
          <div>{card.client?.firstname}</div>
          <div>{card?.price}</div>
          <div>{card.user?.firstname}</div>
          <div>{formatDateToDDMMYYYY(new Date(card?.createdAt))}</div>
        </div>
      ))}
    </div>
  )
}
export default CardTwo
